export default "__VITE_ASSET__bc188868__"